// extracted by mini-css-extract-plugin
export default {"modalBody":"ScoringAccuracyTipsModal_modalBody__9NNiS","note":"ScoringAccuracyTipsModal_note__nD2fz"};